import getScrollAccessor from './getScrollAccessor';
export default getScrollAccessor('pageXOffset');


//////////////////
// WEBPACK FOOTER
// ./node_modules/dom-helpers/esm/scrollLeft.js
// module id = 383
// module chunks = 0